const state = () => ({
  attachmentStates: {},
});


const getters = {
  get: state => state.attachmentStates,
  list: state => Object.values(state.attachmentStates),
};

const mutations = {
  delete(state, attachmentIds) {
    attachmentIds.forEach(attachmentId => {
      delete state.attachmentStates[attachmentId];
    });
  },
  set(state, attachmentStates) {
    attachmentStates.forEach(attachmentState => {
      state.attachmentStates[attachmentState.attachmentId] = attachmentState;
    });
  },
};

const actions = {
  send({ dispatch, commit, getters, rootGetters }, params) {
    const existingState = getters.get[params.attachmentId];
    const defaultParams = {
      currentTimestamp: existingState?.currentTimestamp || 0,
      elapsedSeconds: existingState?.elapsedSeconds || 0,
    };
    const mergedParams = { ...defaultParams, ...params.attachmentState };
    commit('set', [mergedParams]);
    return rootGetters['session/ajax'].post('/attachment_states', { attachmentState: mergedParams });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
